import { Outlet } from 'react-router-dom';

import { AppLayout } from 'components/navigation/AppLayout';

const FavoritesWatchlistLayout = () => {
  return (
    <AppLayout>
      <Outlet />
    </AppLayout>
  );
};

export default FavoritesWatchlistLayout;
